import type {
  ApiNotification,
  UiNotification,
} from '../schemas/notification.schema';
import type { FetchNotificationsArgs } from './types/notifications.types';

import { mapNotificationFromApi } from './mappers/notifications.mappers';
import { postWithPagination, destroy, get, put } from './axios';

export async function fetchNotifications({
  limit = '20',
  page = '1',
}: FetchNotificationsArgs = {}) {
  const response = await postWithPagination<ApiNotification[]>(
    '/v2/notifications/list',
    { limit, offset: page },
  );
  return {
    ...response,
    data: response?.data?.map(mapNotificationFromApi) as UiNotification[],
  };
}

export async function fetchUnreadNotificationsCount() {
  const response = await get<{ count: number }>(
    '/v2/notifications/unread-count',
  );
  return response?.count ?? 0;
}

export async function markAllNotificationsRead() {
  await put('/v2/notifications/mark-all-read');
}

export async function deleteNotification(id: string) {
  await destroy(`/v2/notifications/${id}`);
}
